var styles = {"fontElementMap":"-ylKa","orderedlist":"XUjVX","bulletedlist":"juncn","listItem":"RiZl9"};

export { styles as s };
//# sourceMappingURL=lists-665efcca.js.map
